import { ref, computed } from 'vue'

const loadingCount = ref(0)
export default () => {
  const start = () => (loadingCount.value = loadingCount.value + 1)
  const stop = () => (loadingCount.value = loadingCount.value - 1)
  const isLoading = computed(() => loadingCount.value > 0)
  return { isLoading, start, stop }
}
